export const successState = setNotificationText => {
  setNotificationText();
  return true;
};

export const formatResults = results => ({
  type: 'error',
  errors: results,
});
